import { Editor } from 'tinymce';
import { Component, Vue, Prop, Inject, Emit } from 'vue-property-decorator';
import { DtoCurrentUser, createDtoCurrentUser } from '@/common/types/user/DtoCurrentUser';

@Component({
    name: 'NoviTinyMce'
})
export default class NoviTinyMce extends Vue {
    @Prop({ required: false, default: "" })
    regionName!: string;

    @Prop({ required: false, default: "" })
    component!: string;

    @Prop({ required: false, default: "" })
    componentId!: string;

    @Prop({ required: true, default: "" })
    value!: string;

    @Prop({ required: true, default: false })
    simpleEditor!: boolean;

    @Inject('user')
    currentUser!: DtoCurrentUser;

    html: string = "";

    get parsedRegionName() {
        return this.regionName.replace(" ", "_");
    }

    get editableRegionName() {
        return "editable_" + this.parsedRegionName;
    }

    get hiddenHtmlInputName() {
        return this.editableRegionName + "_html";
    }

    get hiddenOriginalHtmlInputName() {
        return this.editableRegionName + "_html_original";
    }

    get isEditable() {
        return this.currentUser.hasSomeAdminAccess;
    }

    get staticHtml() {

        //@ts-ignore
        //if (typeof ProcessContentForView != "undefined") {
        //    //@ts-ignore
        //    return ProcessContentForView(this.html);
        //}
        return this.html;
    }

    mounted() {
        this.html = this.value;
        if (!this.isEditable)
            return;

        var self = this;

        document.addEventListener<any>('tinymceBlurred', function (evt: CustomEvent<Editor>) {
            var content = evt.detail.getContent();
            self.emitInput(content);
        }, false);

        // We have to fire this custom event to let the INLINE editor (not the classic editor ) know that the content regions are loaded 
        // and ready to be initialized.
        // For this to work, we have to make sure that the `_StaticPageRegionJS.cshtml` partial view is loaded on the page. This partial view
        // looks for a `ViewData["WaitToInitTinyMce"] = true.ToString();` value. If that value is present (from the parent page), then the 
        // partial view will NOT initialize the inline TinyMCE editor and instead allow other scripts (like this one) to do so 
        // with this custom event.
        const contentRegionsLoadedEvent = new CustomEvent(window.noviCmsNamespace.contentRegionsLoadedEvent, { detail: {}, bubbles: true, cancelable: true });

        // If the DOMContentLoaded event has already fired and the readyState is loaded, we'll just fire the custom event
        if (document.readyState === 'complete') {
            document.dispatchEvent(contentRegionsLoadedEvent);
        }
        // If the document.readyState is in interactive mode (i.e. scripts and images still loading), we'll wait a bit and then
        // fire the custom event to insure that the TinyMCE scripts have loaded
        else if( document.readyState === 'interactive') {
            const tinyMCEInitTimeout = setTimeout(() => {
                document.dispatchEvent(contentRegionsLoadedEvent);
                clearTimeout(tinyMCEInitTimeout);
            }, 500);
        }
        // Otherwise, we'll wait for the DOM to load and then fire the custom event
        else {
            document.addEventListener('DOMContentLoaded', function () {
                document.dispatchEvent(contentRegionsLoadedEvent);
            });
        }
    }

    beforeDestroy() {
        if (!this.isEditable)
            return;

        const tiny = (window as any).tinymce;
        if (!tiny || typeof tiny.execCommand !== 'function') {
            return;
        }

        // Only remove if this editor exists
        if (typeof tiny.get === 'function' && !tiny.get(this.editableRegionName)) {
            return;
        }

        try {
            tiny.execCommand("mceRemoveEditor", true, this.editableRegionName);
        } catch (e) {
            console.error('TinyMCE mceRemoveEditor failed', this.editableRegionName, e);
        }
    }

    @Emit('input')
    emitInput(html: string) {
        return html;
    }
}